import { render, staticRenderFns } from "./LocoSectionGraphs.vue?vue&type=template&id=0d475dcc&scoped=true&"
import script from "./LocoSectionGraphs.vue?vue&type=script&lang=ts&"
export * from "./LocoSectionGraphs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d475dcc",
  null
  
)

export default component.exports